module.exports = __webpack_public_path__ + "static/media/two.4d7bd8fd.svg";